<template>
  <div v-loading="pageLoading">
    <div>
      <el-form :model="form"
               :label-width="formLabelWidth"
               style="margin: auto;width: 1000px;"
               ref="form"
               >
        <el-form-item label="職員編號"  
        prop="workNo"
        :rules="[
            { required: true, message: '賬號不能为空' },
          ]"
        
        >
          <el-input v-model="form.workNo"
                    placeholder="請輸入職員編號"
                    autocomplete="off"
                    style="width: 80%;"></el-input>
        </el-form-item>
        <el-form-item label="名字" required>
          <el-input v-model="form.name"
                    placeholder="請輸入名字"
                    autocomplete="off"
                    style="width: 80%;"></el-input>
        </el-form-item>
        <el-form-item label="賬號">請在APP/後台用戶管理處設置</el-form-item>
        <el-form-item label="密碼">請在APP/後台用戶管理處設置</el-form-item>
        <el-form-item label="性別" required>
          <el-select v-model="form.gender"
                     placeholder="請選擇性別"
                     style="width: 80%;">
            <el-option label="M"
                       value="M"></el-option>
            <el-option label="F"
                       value="F"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分公司" required>
          <el-select v-model="form.manRegionId"
                     filterable
                     reserve-keyword
                     placeholder="請選擇分公司"
                     style="width: 80%;"
                     @change="selectRegion"
                     :loading="region.length == 0">
            <el-option v-for="item in region"
                       :key="item.id"
                       :label="item.regionName"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部門/物業" required>
          <el-select v-model="form.manBranchId"
                     filterable
                     reserve-keyword
                     :placeholder="!form.manRegionId ? '請先選擇分公司' : '請選擇部門/物業'"
                     style="width: 80%;"
                     @change="selectBranch"
                     :disabled="!form.manRegionId">
            <el-option v-for="item in filiale"
                       :key="item.id"
                       :label="item.branchName"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用戶組別" required>
          <el-select v-model="form.manDepartmentId"
                     filterable
                     reserve-keyword
                     :placeholder="!form.manBranchId ? '請先選擇部門/物業' : '請選擇用戶組別'"
                     style="width: 80%;"
                     :disabled="!form.manBranchId">
            <el-option v-for="item in department"
                       :key="item.id"
                       :label="item.departmentName"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="職位" required>
          <el-select v-model="form.manPositionId"
                     filterable
                     reserve-keyword
                     :placeholder="!form.manBranchId ? '請先選擇部門主管/物業主管' : '請選擇職位'"
                     style="width: 80%;"
                     :disabled="!form.manBranchId">
            <el-option v-for="item in position"
                       :key="item.id"
                       :label="item.positionName"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="入職日期" required>
          <el-date-picker type="date"
                          v-model="form.entryDate"
                          placeholder="选择时间"
                          value-format="yyyy-MM-dd"
                          style="width: 336px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="聯繫方式" required>
          <el-input v-model="form.contactWay"
                    placeholder="請輸入手機號"
                    autocomplete="off"
                    style="width: 80%;"></el-input>
        </el-form-item>
        <el-form-item>
          <!-- 佔位 -->
        </el-form-item>
        <el-form-item label="英文名" required>
          <el-input v-model="form.address"
                    placeholder="請輸入英文名"
                    autocomplete="off"
                    style="width: 180%;"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button @click="$router.back(-1)">取 消</el-button>
        <el-button type="primary"
                   @click="addUser">確 定</el-button>
      </div>
      <el-button class="back"
                 @click="$router.back(-1)">返 回</el-button>
    </div>
  </div>
</template>

<script>
var that;
export default {
  data () {
    return {
      pageLoading: false,
      form: {
        workNo: '',
        name: '',
        manRegionId: '',
        manBranchId: '',
        manDepartmentId: '',
        manPositionId: '',
        entryDate: '',
        contactWay: '',
        address: '',
        gender: ''
      },
      formLabelWidth: '100px',
      region: [],
      filiale: [],
      department: [],
      position: [],
    };
  },
  mounted () {
    $('#pageHead').text('新增用戶');
    // 获取级联
    this.$store.dispatch('commonData/getEchoDistrictBranchDepartmentList').then(() => {
      this.region = this.$store.state.commonData.echoDistrictBranchDepartmentList
    })
  },
  methods: {
    addUser () {
      var form = that.form;
      for (let item in form) {
        if (form[item] == '') {
          this.$message({
            type: 'warning',
            message: '請將數據填寫完整!'
          });
          return;
        }
      }
      // if (!(/^[0-9]*$/.test(form.workNo))) {
      //   this.$message({
      //     type: 'warning',
      //     message: '職員編號只能使用數字'
      //   })
      //   return
      // }
      if (!form.contactWay) {
        this.$message({
          type: 'warning',
          message: '請填寫手機號!'
        });
        return;
      }
      this.pageLoading = true
      this.axios({
        url: '/manage/addComUser',
        method: 'post',
        params: form
      })
        .then(res => {
          if (res) {
            that.$message({
              message: res.message,
              showClose: true,
              type: 'success'
            });
            setTimeout(function () {
              that.$router.go(-1);
            }, 1000);
          }
        })
        .catch(e => {
          console.log(e);
          that.pageLoading = false
        });
    },
    selectRegion (val) {
      // 已選擇地區
      var reg = this.region;
      for (let i = 0; i < reg.length; i++) {
        if (reg[i].id == val) {
          that.form.manBranchId = '',
            that.form.manDepartmentId = '',
            that.form.manPositionId = '',
            that.filiale = reg[i].branchList;
          this.department = [];
          this.position = [];
          break;
        }
      }
    },
    selectBranch (val) {
      // 已選分公司
      var fil = that.filiale;
      for (let i = 0; i < fil.length; i++) {
        if (fil[i].id == val) {
          that.form.manDepartmentId = '';
          that.form.manPositionId = '';
          that.department = fil[i].departmentList;
          that.position = fil[i].positionList;

          // this.position = [];
          break;
        }
      }
    },
    // selectDep (val) {
    //   // 已選分部門
    //   var dep = that.department;
    //   for (let i = 0; i < dep.length; i++) {
    //     if (dep[i].id == val) {
    //       that.form.manPositionId = '',
    //         that.position = dep[i].positionList;
    //       break;
    //     }
    //   }
    // }
  },
  created () {
    that = this;
  }
};
</script>

<style scoped>
.btn {
  margin-left: 20px;
}
.dialog-footer {
  display: flex;
  justify-content: space-around;
  width: 400px;
  margin: auto;
}
.el-form-item {
  width: 500px;
  display: inline-block;
}
.back {
  position: absolute;
  top: 90px;
  right: 45px;
}
</style>
